import { Flex } from '@grupoboticario/flora-react';
import { ExclamationMarkHexagonIcon } from '@grupoboticario/flora-react-icons';
import config from 'config';
import {
  ButtonGhost,
  ButtonSolid,
  Container,
  Layout,
  Link,
  ResponsiveFloraTypography,
  Text,
} from 'ui/components/primitives';
import useHandleClick from './useHandleClick';
import { theme } from 'ui/theme';

const ErrorProcess = () => {
  const { handleRedirectToHome, handleTrackClick } = useHandleClick();

  return (
    <>
      <Layout horizontalAlign="left" data-testid="error-process">
        <Container marginTop="sp-10" marginBottom="sp-10">
          <Flex justify="center">
            <ExclamationMarkHexagonIcon
              css={{ color: theme.colors.action.nonInteractive.emphasis }}
              size="64"
            />
          </Flex>
        </Container>
      </Layout>
      <Layout>
        <Container marginTop="sp-0" marginBottom="sp-0">
          <ResponsiveFloraTypography
            as="h1"
            fontSize="subtitle"
            color={`${theme.colors.action.nonInteractive.emphasis}`}
            css={{
              textAlign: 'center',
              margin: 0,
            }}
          >
            Não foi possível calcular descontos e brindes
          </ResponsiveFloraTypography>
        </Container>
      </Layout>
      <Layout>
        <Container marginTop="sp-6" size="2/3" marginBottom="sp-6">
          <Text color="medium-light-1" textAlign="center" variant="body-medium-standard">
            Por favor, recarregue a página e clique em ”Continuar a compra” para tentar novamente
          </Text>
        </Container>
      </Layout>
      <Layout data-testid="error" verticalAlign="center">
        <Container marginBottom="sp-2" marginTop="sp-6" size="2/3">
          <ButtonSolid data-testid="reload-button" onClick={handleRedirectToHome} stretch>
            Recarregar a página
          </ButtonSolid>
        </Container>
      </Layout>
      <Layout data-testid="error" verticalAlign="center">
        <Container marginTop="sp-2" size="2/3">
          <Link to="/logout" target="_self" onClick={handleTrackClick}>
            <ButtonGhost stretch>Voltar para o portal {config.app.name}</ButtonGhost>
          </Link>
        </Container>
      </Layout>
    </>
  );
};

export default ErrorProcess;
